import { usePunditUserContext } from "@/react/contexts";

export const useIsVideoAnalyticsEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  return Boolean(currentCommunitySettings?.cms_video_analytics_enabled);
};
